import { UserManager, WebStorageStateStore} from 'oidc-client-ts';

// OIDC configuration
let oidcProviderDomain = process.env.VUE_APP_OIDC_AUTHORITY;
let clientId = process.env.VUE_APP_OIDC_CLIENT_ID;
let scopes = "openid email profile uid"
let baseURL = process.env.VUE_APP_BEAPI;
let apiVersion =  process.env.VUE_APP_API_VERSION ? `/${process.env.VUE_APP_API_VERSION}` : '';

let instance;

// OIDC Client
export const getOidcClient = (isMyBeauty) => {
  if (instance) {
      return instance;
  }

  instance = new UserManager({
    userStore: new WebStorageStateStore(),  
    authority: oidcProviderDomain,
    client_id: clientId,
    redirect_uri: `${window.location.origin}${isMyBeauty ? '/mybeauty' : ''}/callback`,
    response_type: 'code',
    scope: scopes,
    post_logout_redirect_uri: window.location.origin + '/home?action=logout',
    accessTokenExpiringNotificationTime: 10,
    automaticSilentRenew: false,
    filterProtocolClaims: false,
    loadUserInfo: false,
    includeIdTokenInSilentRenew : false,
    metadata: {
        token_endpoint: `${baseURL}/auth${apiVersion}/api/token`,  //'https://apig.harrods.com/drc-dev4/v4/api/token',
        authorization_endpoint: oidcProviderDomain + '/authorize',
        userinfo_endpoint: oidcProviderDomain + '/userinfo',
        revocation_endpoint: oidcProviderDomain + '/revoke',
        introspection_endpoint:oidcProviderDomain + '/introspect',
        end_session_endpoint: oidcProviderDomain + '/revoke',
        jwks_uri: oidcProviderDomain + '/.well-known/jwks',
        issuer: oidcProviderDomain + '/'
      }
  });
  return instance;
}
